const ENGINEERING_LEVELS = [
  { id: "ae18ed16-aba3-46fd-a729-9868e558ed52", name: "Intermediate - E2" },
  { id: "29cb521f-6fd8-4465-bb68-244228b772c8", name: "Senior - E3" },
  { id: "23975b4a-6177-46ad-b087-cfe04d91bea9", name: "Staff - E4" },
  { id: "fdb6e82f-f637-4a12-8153-405ce4c94903", name: "Principal - E5" },
  { id: "9a0eba0b-74f8-4cf9-8a11-7e82548dda98", name: "Distinguished - E6" },
];

export default ENGINEERING_LEVELS;
